import reducer from './reducers';
import * as patientFlowsActions from './actions';
import * as patientFlowsSelectors from './selectors';

export { patientFlowsActions, patientFlowsSelectors };
export default reducer;
